"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustItems = [{
  id: "bkr",
  type: "image",
  src: "https://proffsbadrum.se/wp-content/uploads/2026/09/BKR-GVK-komprimerad.webp?v=7rvm3l8tr7k",
  alt: "BKR - Auktoriserat våtrumsföretag",
  label: "Behöriga samarbetspartners"
}, {
  id: "pci",
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/pci_partner_logo.png",
  alt: "Säker Vatten Auktorisation",
  label: "Auktoriserat VVS-företag"
}, {
  id: "established",
  type: "icon",
  icon: ShieldCheck,
  label: "Fackmässigt utförande"
}];
export default function OurQualitySeal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="187515" id="trygghet-kvalitet" className="bg-muted py-12 md:py-16 border-y border-border/50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`flex flex-wrap items-center justify-center gap-12 md:gap-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {trustItems.map((item, i) => <div key={item.id} data-index={i} className="group flex flex-col items-center gap-4 cursor-default">
              {item.type === "image" ? <div className="h-16 flex items-center justify-center">
                  <img src={item.src} alt={item.alt} className="max-h-full w-auto object-contain grayscale opacity-40 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 ease-out" />
                </div> : <div className="h-16 flex items-center justify-center">
                  {item.icon && <item.icon className="h-12 w-12 text-muted-foreground/40 group-hover:text-primary transition-colors duration-500 ease-out" strokeWidth={1.5} />}
                </div>}
              <span className="text-[10px] md:text-xs font-default font-semibold uppercase tracking-widest text-muted-foreground group-hover:text-foreground transition-colors duration-500">
                {item.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}